<!-- @format -->

<ng-container *transloco="let t">
  <div class="modal-header">
    <h2 class="modal-title">{{ t("SIS_COMPONENTS.ACCESS_DENIED.REQUIRED_ACCESS_PERMISSIONS.TITLE") }}</h2>
    <sis-modal-close-button />
  </div>
  <div class="modal-body">
    <p>{{ t("SIS_COMPONENTS.ACCESS_DENIED.REQUIRED_ACCESS_PERMISSIONS.DESCRIPTION") }}</p>
    @for (name of localizedNames; track name; let last = $last) {
      <span class="fw-semibold">{{ name }}</span>
      @if (!last) {
        {{ t("SIS_COMPONENTS.ACCESS_DENIED.REQUIRED_ACCESS_PERMISSIONS.OR") }}
      }
    }
  </div>
</ng-container>
